import React from "react";

type CardSide = "front" | "back";

export type IDCardProps = {
  side: CardSide;

  logo?: string;
  roleLabel?: string;
  roleGradient?: string;
  textColorClass?: string;

  name?: string;
  phone?: string;
  email?: string;
  address?: string;
  fatherName?: string;
  motherName?: string;
  fatherphone?: string;
  motherPhone?: string;
  studentClass?: string;
  image?: string;
  QRCode?: string

  QRBorder?: string;
  footerEmail?: string;
  schoolName?: string
};

const IDCard: React.FC<IDCardProps> = ({
  side,
  logo,
  roleLabel,
  roleGradient,
  textColorClass,
  name,
  phone,
  email,
  address,
  footerEmail,
  fatherName,
  fatherphone,
  motherName,
  motherPhone,
  QRBorder = "border-success-700",
  studentClass,
  image,
  QRCode,
  schoolName
}) => {
  return (
    <div className="border-[12px] border-b-[28px] border-[#252526] rounded-xl p-3 max-w-72">
      <div className="bg-white relative rounded-lg h-full min-h-[340px] pb-2">
        {/* role tag */}
        {side === "front" && (
          <p
            style={{ background: roleGradient }}
            className="text-3xl font-medium text-white absolute uppercase -bottom-3 left-8
    origin-bottom-left -rotate-90 pl-4 pr-20 p-1 rounded-br-lg"
          >
            {roleLabel}
          </p>
        )}

        {/* FRONT */}
        {side === "front" && (
          <div className="flex flex-col items-center justify-center gap-3 px-10 pt-4">
            <img src={logo} alt="logo" className="w-40"  />

            <img src={image} alt="" className="bg-neutral-100 w-32 object-cover aspect-square rounded-xl" />

            <div className="grid place-content-center  gap-3 mt-4 w-full">
              {name && (
                <Field
                  label={`${roleLabel} Name`}
                  value={name}
                  color={textColorClass}
                />
              )}
              {phone && (
                <Field
                  label={`${roleLabel} Phone`}
                  value={phone}
                  color={textColorClass}
                />
              )}
              {studentClass && (
                <Field
                  label={`${roleLabel} Class`}
                  value={studentClass}
                  color={textColorClass}
                />
              )}
            </div>
          </div>
        )}

        {/* BACK */}
        {side === "back" && (
          <div className="flex flex-col rounded-xl items-center gap-4 pt-4 text-[10px] h-full justify-between">
            <img src={logo} alt="logo" className="w-40" />

            <div className={`gap-y-3 grid px-3 ${textColorClass}`}>
              {email && <Row label={`${roleLabel} Email`} value={email} />}
              {address && (
                <Row label={`${roleLabel} Address`} value={address} />
              )}
              {fatherName && <Row label={`Father Name`} value={fatherName} />}
              {fatherphone && (
                <Row label={`Father Phone`} value={fatherphone} />
              )}
              {motherName && <Row label={`Mother Name`} value={motherName} />}
              {motherPhone && (
                <Row label={`Mother Phone`} value={motherPhone} />
              )}
            </div>

            <div className={`border-8 ${QRBorder} w-24 mt-4 p-1 aspect-square`} >
              <img src={QRCode} alt="" className="bg-neutral-100 w-32 object-cover aspect-square rounded-xl" />
            </div>

            <div className="text-neutral-400 text-center">
              <p className="font-bold">If found please return to,</p>
              <p className="font-medium">{schoolName}</p>
            </div>

            {footerEmail && (
              <p className="absolute -bottom-8 left-0 w-full text-center text-[10px] text-neutral-100">
                {footerEmail}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default IDCard;

/* ---------- helpers ---------- */

type FieldProps = {
  label: string;
  value: string;
  color: string;
};

const Field: React.FC<FieldProps> = ({ label, value, color }) => (
  <div>
    <label className="text-neutral-400 text-[10px] font-medium">{label}</label>
    <p className={`text-xs font-bold ${color}`}>{value}</p>
  </div>
);

type RowProps = {
  label: string;
  value: string;
};

const Row: React.FC<RowProps> = ({ label, value }) => (
  <div className="grid grid-cols-[0.5fr_1fr] gap-x-2">
    <label className="text-neutral-400 text-nowrap font-medium">{label}</label>
    <p className={`font-bold`}>{value}</p>
  </div>
);
